import {FC} from "react";
import {ReportPage, ReportSalesInGraphSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {searchReportStation,} from "../../../serviceBroker/transationReportApiServiceBroker";
import {PageEnum, SalesInGraphReportSearchParamsModel} from "../../../models";

export const ReportStationsPage: FC = () => {
    const initialState: SalesInGraphReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        userId: getUserId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportStation}
            searchHeader={getPageNameByPageId(PageEnum.ReportStationOfPOS)}
            SearchPanel={ReportSalesInGraphSearchPanel}
            formId={PageEnum.ReportStationOfPOS}
        />
    );
};
